import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";
import { Quest } from "@quest_editor/mocks";
import { formatDateTime } from "utils/common/formatUtils";

const BasicInfoSection = ({ quest }: { quest: Quest }) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_detail.section.basic_info")}
      rightContent={
        <SubActionButton
          size="small"
          component={Link}
          to="edit"
        >
          {t("quest_detail.button.edit")}
        </SubActionButton>
      }
      rows={[
        {
          label: t("quest_detail.field.basic_info.name"),
          children: <Typography color="text.secondary">{quest.name}</Typography>,
        },
        {
          label: t("quest_detail.field.basic_info.description"),
          children: (
            <Typography color="text.secondary" sx={{ whiteSpace: "pre-wrap" }}>
              {quest.description}
            </Typography>
          ),
        },
        {
          label: t("quest_detail.field.basic_info.note"),
          children: <Typography color="text.secondary">{quest.note ?? ""}</Typography>,
        },
        {
          label: t("quest_detail.field.basic_info.reward"),
          children: <Typography color="text.secondary">{quest.reward}</Typography>,
        },
        {
          label: t("quest_detail.field.basic_info.image"),
          children: <Box component="img" src={quest.imageUrl} />,
        },
        {
          label: t("quest_detail.field.basic_info.period"),
          children: (
            <Typography color="text.secondary">
              {t("quest_detail.field.basic_info.period_label", {
                start_at: formatDateTime(quest.startAt),
                end_at: formatDateTime(quest.endAt),
              })}
            </Typography>
          ),
        },
      ]}
    />
  );
};

export default BasicInfoSection;
